<template>
  <!-- Toast notifications are managed globally via window.$toast -->
  <div id="toast-container" aria-live="polite" aria-atomic="false"></div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  // Initialize toast system
  const container = document.getElementById('toast-container')
  if (!container) return

  const createToast = (type, title, msg, duration = 4000) => {
    const el = document.createElement('div')
    el.className = `toast toast-${type}`

    const colors = {
      success: '#10b981',
      error: '#ef4444',
      warning: '#f59e0b',
      info: '#3b82f6',
    }
    const icons = {
      success: '✓',
      error: '✗',
      warning: '⚠',
      info: 'ℹ',
    }

    el.innerHTML = `
      <div class="toast-icon" style="background:${colors[type] || colors.info}20;color:${colors[type] || colors.info}">
        ${icons[type] || icons.info}
      </div>
      <div class="toast-body">
        <div class="toast-title">${title}</div>
        ${msg ? `<div class="toast-msg">${msg}</div>` : ''}
      </div>
      <button class="toast-close" onclick="this.parentElement.remove()">×</button>
    `
    el.style.cssText = `pointer-events:auto;`
    container.appendChild(el)
    setTimeout(() => el.remove(), duration)
    return el
  }

  window.$toast = {
    success: (title, msg, duration) => createToast('success', title, msg, duration),
    error: (title, msg, duration) => createToast('error', title, msg, duration),
    warning: (title, msg, duration) => createToast('warning', title, msg, duration),
    info: (title, msg, duration) => createToast('info', title, msg, duration),
  }
})
</script>
